<template>
  <div class="where-found">
    <ag-loading v-if="loading" />
    <div class="position-relative" v-else>
      <div class="btn-container" v-if="hashDetail">
        <button
          type="button"
          class="
            border-0
            ag-button ag-button_radius
            pr-4
            pl-4
            ag-button_secondary
            collapse-button
          "
          @click="setCollapseStatus()"
        >
          <span v-if="!expandStatus">{{$t("expandAll")}}</span>
          <span v-if="expandStatus">{{$t("collapse")}}</span>
        </button>
      </div>
      <!--<ag-card :module="module"></ag-card> -->
      <div class="accordion-header">
        <div class="info-containerX">
          <p class="side-bar">Endpoint Count</p>
        </div>
        <div class="info-containerX">
          <p class="side-bar">Count</p>
        </div>
      </div>
      <div id="accordion">
        <div
          class="card"
          v-for="(company, index) in companyData"
          :key="index"
          id="collapse-0"
          v-show="company.totalHashCount > 0"
        >
          <div
            class="card-header"
            style="
              display: flex;
              justify-content: space-between;
              padding-right: 8rem;
            "
            id="companyHeading"
          >
            <h5 class="mb-0 d-inline">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                :data-target="'#collapse-' + company.companyGuid"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {{ company.companyName }}
              </button>
            </h5>
            <div class="info-container">
              <p class="side-bar">
                {{ $filters.formatNumber(company.totalHashCount) }}
              </p>
              <p class="side-bar">
                {{ $filters.formatNumber(company.computerCount) }}
              </p>
            </div>
          </div>
          <div
            :id="'collapse-' + company.companyGuid"
            class="collapse"
            aria-labelledby="companyHeading"
            data-parent="#accordion"
            v-for="(site, siteIndex) in company.sites"
            :key="siteIndex"
            v-show="
              site.totalHashCount > 0 &&
              ((role === Roles.GroupAdmin &&
                site.groups.find((g) => g.groupGuid === selectedGroup.key)) ||
                (role === Roles.SiteAdmin &&
                  site.siteGuid === selectedSite.key) ||
                (role !== Roles.GroupAdmin && role !== Roles.SiteAdmin))
            "
          >
            <div class="card-body" :id="'child-' + siteIndex">
              <div class="card">
                <div class="card-header site-card d-flex">
                  <p class="site-prefix">Site</p>
                  <a
                    href="#"
                    data-toggle="collapse"
                    :data-target="'#collapse-' + siteIndex + 'A'"
                  >
                    {{ site.siteName }}
                  </a>
                  <div
                    class="info-container ml-auto"
                    style="margin-right: 108px"
                  >
                    <p
                      class="side-bar"
                      v-role="[
                        Roles.AGMSAdmin, Roles.PartnerAdmin,
                        Roles.CompanyAdmin,
                        Roles.SiteAdmin,
                      ]"
                    >
                      {{ $filters.formatNumber(site.totalHashCount) }}
                    </p>
                    <p
                      class="side-bar"
                      v-role="[
                        Roles.AGMSAdmin, Roles.PartnerAdmin,
                        Roles.CompanyAdmin,
                        Roles.SiteAdmin,
                      ]"
                    >
                      {{ $filters.formatNumber(site.computerCount) }}
                    </p>
                  </div>
                </div>
                <div
                  class="card-body collapse group-card justify-content-start"
                  :data-parent="'#child-' + siteIndex"
                  :id="'collapse-' + siteIndex + 'A'"
                  v-for="(group, gIndex) in site.groups"
                  :key="gIndex"
                  v-show="
                    (role === Roles.GroupAdmin &&
                      group.groupGuid === selectedGroup.key) ||
                    role !== Roles.GroupAdmin
                  "
                >
                  <p class="group-prefix">{{$t("group")}}</p>
                  <router-link
                    :to="
                      '/endpoints/company/' +
                      company.companyGuid +
                      '/sites/' +
                      site.siteGuid +
                      '/groups/' +
                      group.groupGuid +
                      '/computers'
                    "
                  >
                    {{ group.groupName }}</router-link
                  >
                  <div class="info-container ml-auto">
                    <p
                      class="side-bar"
                      v-role="[
                        Roles.AGMSAdmin, Roles.PartnerAdmin,
                        Roles.CompanyAdmin,
                        Roles.SiteAdmin,
                        Roles.GroupAdmin,
                      ]"
                    >
                      {{ $filters.formatNumber(group.totalHashCount) }}
                    </p>
                    <p
                      class="side-bar"
                      v-role="[
                        Roles.AGMSAdmin, Roles.PartnerAdmin,
                        Roles.CompanyAdmin,
                        Roles.SiteAdmin,
                        Roles.GroupAdmin,
                      ]"
                    >
                      {{ $filters.formatNumber(group.computerCount) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { useStore } from "@/store";
import { defineComponent } from "vue";
import api from "@/api/index";
import { Roles } from "@/helpers/enums/Roles";
import AgLoading from "@/components/ag-loading/index.vue";
import moment from "moment";
import $ from "jquery";

const store = useStore();

export default defineComponent({
  name: "ag-hashvisibility",
  data() {
    return {
      hashDetail: null,
      Roles: Roles,
      loading: true,
      expandStatus: false,
    };
  },
  components: {
    AgLoading,
  },
  setup() {
    const role = localStorage.getItem("selectedRole")
      ? localStorage.getItem("selectedRole")
      : store.getters.loggedInUser.role;
    const selectedGroup = store.getters.group;
    const selectedSite = store.getters.site;
    return {
      role,
      selectedGroup,
      selectedSite,
    };
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
    companyData() {
      let data = this.hashDetail ? this.hashDetail.companies : [];
      return data;
    },
  },
  methods: {
    setCollapseStatus() {
      if (!this.expandStatus) {
        $(".where-found .collapse").addClass("show");
      } else {
        $(".where-found .collapse").removeClass("show");
      }
      this.expandStatus = !this.expandStatus;
    },
    async GetHashVisibilityHashDetail() {
      this.loading = true;
      const filter = this.selectedRow.filterData;
      let payload = {
        startDate: moment()
          .utc()
          .subtract(7, "days")
          .startOf("day")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS"),
        endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
      };
      if (filter && filter.startDate) {
        payload.startDate = filter.startDate;
      }
      if (filter && filter.endDate) {
        payload.endDate = filter.endDate;
      }
      const res = await api.hashInspections.GetHashVisibilityHashDetail(
        this.selectedRow.hash,
        payload
      );
      this.hashDetail = res.data.entityData;
      this.loading = false;
      setTimeout(() => {
        this.setCollapseStatus();
      }, 100);
    },
  },
  watch: {
    selectedRow() {
      this.GetHashVisibilityHashDetail();
    },
  },
  async created() {
    await this.GetHashVisibilityHashDetail();
  },
});
</script>

<style lang="scss" scoped>
.collapse:not(.show) {
  display: none !important;
}
.btn-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: 1rem;
  button {
    font-size: 12px;
  }
}
.info-container {
  display: flex;
  float: right;
  padding-top: 9px;
  .side-bar {
    margin-bottom: 0;
    width: 90px;
    text-align: center;
    position: relative;
    &::before {
      content: "";
      height: 63px;
      width: 1px;
      background-color: #b7c6cd;
      display: block;
      position: absolute;
      top: -22px;
    }
    &::after {
      content: "";
      height: 63px;
      width: 1px;
      background-color: #b7c6cd;
      display: block;
      position: absolute;
      top: -22px;
      left: 90px;
    }
  }
}
.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0;
  color: #4c8dbb !important;
  a {
    color: #4c8dbb;
  }
}
.accordion-header {
  background-color: #f7f7f7;
  width: 100%;
  padding-right: 8rem;
  height: 1.8rem;
  border-left: 1px solid #d5d5d5b3;
  border-right: 1px solid #d5d5d5b3;
  border-top: 1px solid #d5d5d5b3;
  .info-containerX {
    display: flex;
    float: right;
    padding-top: 2px;
    .side-bar {
      margin-bottom: 0;
      width: 90px;
      text-align: center;
      position: relative;
      font-size: 9px;
      padding-top: 6px;
      &::before {
        content: "";
        height: 28px;
        width: 1px;
        background-color: #b7c6cd;
        display: block;
        position: absolute;
        top: -2px;
      }
      &::after {
        content: "";
        height: 25px;
        width: 1px;
        background-color: #b7c6cd;
        display: block;
        position: absolute;
        top: 0;
        left: 90px;
      }
    }
  }
}
.card {
  .card-header {
    button {
      color: #4c8dbb;
    }
    &::before {
      content: "";
      height: 63px;
      width: 1px;
      background-color: #b7c6cd;
      display: block;
      position: absolute;
      top: 0px;
      left: 17px;
    }
  }
  .site-card {
    padding-left: 3rem;
    position: relative;
    &::before {
      height: 48px;
      left: 16px;
    }
  }
}
.card {
  border-radius: 0px !important;
  margin-top: -3px !important;
}
.group-card {
  padding-left: 4rem;
  display: flex;
  align-items: center;
  min-height: 3rem;
  justify-content: space-between;
  padding-right: 8rem;
  position: relative;
  .info-container {
    p {
      margin-left: 0;
    }
    .side-bar {
      &::before {
        height: 50px;
        top: -17px;
      }
      &::after {
        height: 50px;
        top: -17px;
      }
    }
  }
  p {
    margin-bottom: 0;
    margin-left: 1rem;
  }
  &::before {
    content: "";
    background-color: #b7c6cd;
    width: 1px;
    height: 26px;
    position: absolute;
    top: -1px;
    left: 61px;
  }
}
.group-prefix {
  font-size: 11px;
  color: #b7c6cd;
  position: relative;
  margin-bottom: 0;
  margin-right: 30px;
  &::before {
    content: "";
    background-color: #b7c6cd;
    width: 1rem;
    height: 1px;
    position: absolute;
    top: 8px;
    left: -19px;
  }
  &::after {
    content: "";
    background-color: #b7c6cd;
    width: 1rem;
    height: 1px;
    position: absolute;
    top: 8px;
    left: 36px;
  }
}
.site-prefix {
  font-size: 11px;
  color: #b7c6cd;
  position: relative;
  margin-bottom: 0;
  margin-right: 31px;
  margin-top: 3px;
  &::before {
    content: "";
    background-color: #b7c6cd;
    width: 27px;
    height: 1px;
    position: absolute;
    top: 8px;
    left: -31px;
  }
  &::after {
    content: "";
    background-color: #b7c6cd;
    width: 13px;
    height: 1px;
    position: absolute;
    top: 8px;
    left: 22px;
  }
}
</style>
